function organaxUpdatePurchase(choice) {
  const selected = choice.querySelector('input[type="radio"]:checked');
  const activeCard = selected?.closest('.organax-product__plan-card');
  const sellingPlan = choice.querySelector('[data-organax-selling-plan]');
  if (!sellingPlan) return;

  choice.querySelectorAll('.organax-product__plan-card').forEach((card) => {
    card.classList.toggle('is-selected', card === activeCard);
  });

  const selectedFrequency = activeCard?.querySelector('[data-organax-plan-select]');
  sellingPlan.value = selectedFrequency?.value || selected?.value || '';
  const headline = choice.closest('product-info')?.querySelector('[data-organax-current-price]');
  const amount = headline?.querySelector('[data-organax-current-amount]');
  const compare = headline?.querySelector('[data-organax-current-compare]');
  const selectedOption = selectedFrequency?.selectedOptions[0];
  const planPrice = activeCard?.querySelector('[data-organax-plan-price]');
  const oneTimePrice = activeCard?.querySelector('[data-organax-one-time-price], .organax-product__one-time-price');
  const displayPrice = selectedOption?.dataset.price || planPrice?.dataset.price || oneTimePrice?.dataset.price;
  if (amount && displayPrice) amount.textContent = displayPrice;
  if (compare) {
    compare.textContent = planPrice?.dataset.compare || '';
    compare.hidden = !selectedFrequency && !planPrice;
  }

  if (selectedFrequency) {
    const option = selectedOption;
    const price = activeCard.querySelector('[data-organax-plan-price]');
    const saving = activeCard.querySelector('.organax-product__save');
    const description = activeCard.querySelector('.organax-product__plan-description');
    const tooltipDescription = choice.closest('.organax-product__purchase')?.querySelector('[data-organax-tooltip-description]');
    if (price && option?.dataset.price) price.textContent = option.dataset.price;
    if (saving && option?.dataset.saving) saving.textContent = `Save ${option.dataset.saving}%`;
    if (description && option?.dataset.description) description.textContent = option.dataset.description;
    if (tooltipDescription && option?.dataset.description) tooltipDescription.textContent = option.dataset.description;
  }
}

function organaxEnhancePlanSelects(scope = document) {
  scope.querySelectorAll('[data-organax-plan-select]').forEach((select) => {
    if (select.dataset.enhanced) return;
    select.dataset.enhanced = 'true';
    select.tabIndex = -1;
    const wrap = select.closest('.organax-product__select-wrap');
    const button = document.createElement('button');
    const list = document.createElement('div');
    button.type = 'button';
    button.className = 'organax-product__select-button';
    button.setAttribute('aria-haspopup', 'listbox');
    button.setAttribute('aria-expanded', 'false');
    button.setAttribute('aria-label', 'Delivery frequency');
    list.className = 'organax-product__select-options';
    list.id = `${select.id}-options`;
    list.setAttribute('role', 'listbox');
    list.setAttribute('aria-label', 'Delivery frequency');
    list.hidden = true;
    button.setAttribute('aria-controls', list.id);
    const close = (restoreFocus = false) => {
      list.hidden = true;
      button.setAttribute('aria-expanded', 'false');
      if (restoreFocus) button.focus();
    };
    const sync = () => {
      button.textContent = select.selectedOptions[0]?.textContent || '';
      list.querySelectorAll('[role="option"]').forEach((option) => {
        option.setAttribute('aria-selected', String(option.dataset.value === select.value));
      });
    };
    [...select.options].forEach((option) => {
      const item = document.createElement('button');
      item.type = 'button';
      item.className = 'organax-product__select-option';
      item.setAttribute('role', 'option');
      item.dataset.value = option.value;
      item.textContent = option.textContent;
      item.addEventListener('click', () => {
        select.value = option.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
        sync();
        close(true);
      });
      list.append(item);
    });
    button.addEventListener('click', () => {
      const opening = list.hidden;
      document.querySelectorAll('.organax-product__select-options:not([hidden])').forEach((other) => {
        other.hidden = true;
        other.previousElementSibling?.setAttribute('aria-expanded', 'false');
      });
      list.hidden = !opening;
      button.setAttribute('aria-expanded', String(opening));
      if (opening) list.querySelector('[aria-selected="true"]')?.focus();
    });
    list.addEventListener('keydown', (event) => {
      const options = [...list.querySelectorAll('[role="option"]')];
      const index = options.indexOf(document.activeElement);
      if (event.key === 'Escape') { event.preventDefault(); close(true); }
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        options[(index + (event.key === 'ArrowDown' ? 1 : -1) + options.length) % options.length]?.focus();
      }
      if (event.key === 'Home' || event.key === 'End') {
        event.preventDefault();
        options[event.key === 'Home' ? 0 : options.length - 1]?.focus();
      }
    });
    wrap.append(button, list);
    select.addEventListener('change', sync);
    sync();
    document.addEventListener('pointerdown', (event) => {
      if (!wrap.isConnected) return;
      if (!wrap.contains(event.target)) close();
    });
  });
}

document.addEventListener('change', (event) => {
  const choice = event.target.closest('[data-organax-purchase]');
  if (choice) organaxUpdatePurchase(choice);
});

document.addEventListener('product-info:loaded', (event) => {
  event.target.querySelectorAll('[data-organax-purchase]').forEach(organaxUpdatePurchase);
  organaxEnhancePlanSelects(event.target);
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-organax-purchase]').forEach(organaxUpdatePurchase);
  organaxEnhancePlanSelects();
});
if (document.readyState !== 'loading') organaxEnhancePlanSelects();

if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
  subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
    document.querySelectorAll('product-info[id^="MainProduct"] [data-organax-purchase]').forEach(organaxUpdatePurchase);
  });
}

// Seal adds a second selector and selling_plan input to product forms after page load.
// Keep its Shopify selling plans as the source of data while the redesigned selector
// remains the only storefront control and the only submitted plan value.
const organaxGuardedForms = new WeakSet();

function organaxGuardProductForms() {
  document.querySelectorAll('product-info[id^="MainProduct"] form[data-type="add-to-cart-form"]').forEach((form) => {
    if (organaxGuardedForms.has(form)) return;
    organaxGuardedForms.add(form);

    const cleanSealInjection = () => {
      form.querySelectorAll('.sealsubs-target-element, input[data-sls-selling_plan]').forEach((node) => node.remove());
    };

    new MutationObserver((mutations) => {
      if (mutations.some(({ addedNodes }) => [...addedNodes].some((node) =>
        node.nodeType === 1 && (node.matches?.('.sealsubs-target-element, input[data-sls-selling_plan]') || node.querySelector?.('.sealsubs-target-element, input[data-sls-selling_plan]'))
      ))) cleanSealInjection();
    }).observe(form, { childList: true, subtree: true });

    form.addEventListener('submit', cleanSealInjection, { capture: true });
    form.addEventListener('formdata', (event) => {
      const selectedPlan = form.closest('product-info')?.querySelector('[data-organax-selling-plan]')?.value;
      event.formData.delete('selling_plan');
      if (selectedPlan) event.formData.set('selling_plan', selectedPlan);
    });
    cleanSealInjection();
  });
}

document.addEventListener('DOMContentLoaded', organaxGuardProductForms);
document.addEventListener('product-info:loaded', organaxGuardProductForms);
if (document.readyState !== 'loading') organaxGuardProductForms();
